import { __awaiter } from "tslib";
import { useAemConfig } from '@as-react/common-components';
import { customerMutations, customerQueries } from '@as-react/common-queries';
import { ErrorMessage } from '@as-react/common-types';
import { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { queryClient } from '@as-react/common-queries';
export const useCreateAccount = () => {
    const [errorMessage, setErrorMessage] = useState(null);
    const { defaultRequestParams, servicesEndpoint } = useAemConfig();
    const { getLanguages } = customerQueries({ servicesEndpoint, defaultRequestParams });
    const { createAccountMutation } = customerMutations({ servicesEndpoint, defaultRequestParams });
    const { mutateAsync: create } = useMutation(createAccountMutation());
    const createAccount = (customerData) => __awaiter(void 0, void 0, void 0, function* () {
        setErrorMessage(null);
        try {
            const languages = yield queryClient.fetchQuery(getLanguages());
            const customerLanguage = languages.find(lang => lang.languageCode === customerData.language.toUpperCase());
            if (customerLanguage === null || customerLanguage === void 0 ? void 0 : customerLanguage.idLanguage) {
                customerData.idLanguage = customerLanguage.idLanguage;
            }
            yield create({ customerData });
            return true;
        }
        catch (_e) {
            setErrorMessage(ErrorMessage.GENERAL_ACCOUNT);
            return false;
        }
    });
    return { createAccount, errorMessage };
};
